import React from 'react'
import { connect } from 'react-redux'
import { PlusOutlined } from '@ant-design/icons'
import {
  Input,
  Upload,
  message,
  Radio,
  Button,
  Collapse,
  Divider,
  Select,
  Popover,
  Form,
  Typography,
} from 'antd'
import { withRouter, RouteProps } from 'react-router-dom'
import { setBaseInfo } from '@store/actions'
import api from '@services/api'
import lego from '@services/lego'
import './index.scss'
import { FormComponentProps } from '@ant-design/compatible/es/form'
import bxlutils from 'bxl-utils'
import ColorPicker from '@components/ColorPicker/index'
import { PRODUCTLINK } from '@lib/constant'
import unit from '@/utils/utils'
import { getUserName, getAuthHeaders } from '@/utils/session'
import { withTranslation } from 'react-i18next'
import { generateContentWithVersion } from '@/utils/lego'

const FormItem = Form.Item
const Option = Select.Option
const { Panel } = Collapse
const mapDispatchToProps = dispatch => ({
  editConfig: (value, type) => {
    dispatch(setBaseInfo(type, value))
  },
})
const mapStateToprops = state => ({
  base: state.tree,
  templateList: state.common.templateList,
  baseInfo: state.baseData,
})

interface dispatchProps extends FormComponentProps {
  editConfig: (e, type) => void
}
interface stateProps extends dispatchProps {
  base: any
  isUpdate: any
  config: any
}
const initState = {
  isUpdate: false,
  saveLoading: false,
  visible: false,
  categories: [],
}
interface State {
  isUpdate: boolean
  saveLoading: boolean
  visible: boolean
  categories: { tabName: string; categoryIds: string[] }[]
}
class BaseConfig extends React.Component<stateProps & RouteProps & any, State> {
  state: State = initState
  private formRef = React.createRef<any>()
  componentDidMount() {
    lego.getLegoCategories().then(res => {
      this.setState({
        categories: res.data,
      })
    })
    if (this.props.match.params && this.props.match.params.id) {
      this.setState({
        isUpdate: true,
      })
    }
  }

  validatePageId = (rule, value, callback) => {
    const { form } = this.props
    const reg = /[^\x00 -\xff]/g
    if (!reg.test(value)) {
      form.validateFields(['pageId'], { force: true })
    } else {
      return new Error('pageId格式错误')
    }
    callback()
  }
  editUtmConfig = (value, index, key) => {
    const { config, editConfig } = this.props
    const utmConfig = (config.utmConfig && [...config.utmConfig]) || [
      { utm_source: `lego-${config.pageId}` },
    ]
    utmConfig[index][key] = value
    editConfig(utmConfig, 'utmConfig')
  }
  addUtmChannel = index => {
    const { config, editConfig } = this.props
    const utmConfig = (config.utmConfig && [...config.utmConfig]) || []
    utmConfig.splice(index, 0, {})
    editConfig(utmConfig, 'utmConfig')
  }
  copyLink = item => {
    const { config } = this.props
    if (!config.link) {
      message.error(this.props.t('linkNotGeneratedYet'))
      return
    }
    const eqlink = bxlutils.uri.stringify({
      utm_source: item.utm_source,
      utm_medium: item.utm_medium,
      utm_campaign: item.utm_campaign,
      utm_term: item.utm_term,
      utm_content: item.utm_content,
    })
    const link = config.link + '?' + eqlink
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', link)
    input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      message.success(this.props.t('copySuccess') + ': ' + link, 2)
    }
    document.body.removeChild(input)
  }
  genExtra = (index, utmItem) => {
    return (
      <>
        <Button
          type="link"
          size="small"
          onClick={e => {
            e.stopPropagation()
            this.copyLink(utmItem)
          }}
        >
          {this.props.t('copyLink')}
        </Button>
        <Button
          size="small"
          onClick={e => {
            e.stopPropagation()
            this.addUtmChannel(index)
          }}
        >
          {this.props.t('addSource')}
        </Button>
      </>
    )
  }
  chooseColor = e => {
    this.props.editConfig(e, 'bgColor')
    this.setState({
      visible: false,
    })
  }
  cancelPicker = () => {
    this.setState({
      visible: false,
    })
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeChannel = (e, option) => {
    const { config } = this.props

    const item = PRODUCTLINK.find(item => item.key === e)
    this.props.editConfig(e, 'productLink')

    if (item) {
      const link = `${item.domain}/lego/pages/${config.pageId}/index.html`
      this.props.editConfig(link, 'link')
      this.props.editConfig(item.channel, 'channel')
      this.props.editConfig(item.bucket, 'bucket')
      this.props.editConfig(item.domain, 'domain')
    } else {
      this.props.editConfig(
        `https://baleen-cdn-g.bybieyang.com/lego/pages/${config.pageId}/index.html`,
        'link'
      )
      this.props.editConfig('', 'channel')
      this.props.editConfig('', 'bucket')
      this.props.editConfig('', 'domain')
    }
  }
  uploadImg = e => {
    const fileStatus = e.file
    const basePath = 'https://baleen-cdn-g.bybieyang.com'
    if (fileStatus.status === 'done') {
      const imgPath = fileStatus.response.name
      this.props.editConfig(`${basePath}/${imgPath}`, 'shareImg')
    }
  }
  render() {
    const { config, editConfig, base, templateList } = this.props

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { isUpdate, saveLoading, visible } = this.state
    const formItemLayout = {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    }
    const utmformItemLayout = {
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
    }
    const saveInfo = () => {
      if (
        !config.pageId ||
        !config.shareDes ||
        !config.shareImg ||
        !config.shareTit ||
        !config.merchantId ||
        !config.templateVersion
      ) {
        message.error(this.props.t('fillPageInfo'))
        return
      }
      if (config.categoryIds) {
        config.categoryIds = config.categoryIds.split
          ? config.categoryIds.split(',')
          : config.categoryIds
        const proKey = Object.keys(base).find(com => com.startsWith('ProductList'))
        const proCom = proKey ? base[proKey] : {}
        if (proCom?.config?.products && proCom?.config?.products[0]) {
          config.images = proCom?.config?.products[0]?.product?.images[0] || []
        } else {
          config.images = []
        }
      }
      if (isUpdate) {
        lego
          .updateWebInfo({
            title: base?.root?.config?.title,
            content: generateContentWithVersion(base),
            template: `lego/archVersion/${config.templateVersion || templateList[0]}/index.html`,
          })
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .then(res => {
            message.success(this.props.t('updateSuccess'))
          })
          .catch(err => {
            message.error(err?.response?.data?.error || err.message)
          })
      } else {
        const data = {
          page_id: base.root.config.pageId,
          title: base.root.config.title,
          template: `lego/archVersion/${config.templateVersion}/index.html`,
          content: generateContentWithVersion(base),
          bucket: config.bucket,
          author: getUserName(),
          domain: config.domain,
        }
        this.setState(
          {
            saveLoading: true,
          },
          () => {
            lego
              .saveWebInfo(data)
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              .then(res => {
                message.success(this.props.t('saveSuccess'))
                this.props.history.goBack()
                this.setState({
                  isUpdate: true,
                  saveLoading: false,
                })
              })
              .catch(err => {
                message.error(err?.response?.data?.error || err.message)
                this.setState({
                  saveLoading: false,
                })
              })
          }
        )
      }
    }
    const uploadProps = {
      className: 'avatar-uploader',
      name: 'content',
      action: api.uploadImg,
      showUploadList: false,
      data: {
        format: 'jpg',
        fulldim: '300x300',
        path: 'a.jpg',
      },
      headers: getAuthHeaders() as Record<string, string>,
      beforeUpload: file => {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJPG) {
          message.error('You can only upload JPG/PNG file!')
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          message.error('Image must smaller than 2MB!')
        }
        uploadProps.data.path = `${unit.generateImgName()}${file.name}`
        return isJPG && isLt2M
      },
    }

    const utmForm = [
      {
        placeholder: 'utm_source',
        key: 'utm_source',
        label: 'source',
        default: `lego-${config.pageId}`,
      },
      { placeholder: 'utm_medium', key: 'utm_medium', label: 'medium' },
      { placeholder: 'utm_content', key: 'utm_content', label: 'content' },
      { placeholder: 'utm_campaign', key: 'utm_campaign', label: 'campaign' },
      { placeholder: 'utm_term', key: 'utm_term', label: 'term' },
    ]
    const PaneItem = (index, utmItem) => {
      return (
        <Panel
          header={`${t('channels')}：${utmItem.utm_source ? utmItem.utm_source : 1}`}
          key={index + 1}
          extra={this.genExtra(index, utmItem)}
        >
          <Form className="utmForm" layout="inline">
            {utmForm.map((item, i) => {
              return (
                <FormItem {...utmformItemLayout} label={t(item.label)} key={`form${i}`}>
                  <Input
                    className="input-lar-input"
                    type="text"
                    placeholder={item.default ? item.default : item.placeholder}
                    value={utmItem[item.key] || ''}
                    onChange={e => this.editUtmConfig(e.target.value, index, item.key)}
                  />
                </FormItem>
              )
            })}
          </Form>
        </Panel>
      )
    }
    const content = <ColorPicker handleOk={this.chooseColor} color={config.bgColor}></ColorPicker>
    const errMessage = 'pageId ' + this.props.t('formattingError')
    const t = this.props.t
    return (
      <div className="form-box">
        <div className="utmConfigBox">
          <Collapse>
            {config.utmConfig && config.utmConfig.length > 0
              ? config.utmConfig.map((item, index) => PaneItem(index, item))
              : PaneItem(0, {})}
          </Collapse>
        </div>
        <Divider></Divider>
        <Form className="configBox" ref={this.formRef}>
          <FormItem {...formItemLayout} label={t('title')} required>
            <Input
              className="input-lar-input"
              type="text"
              placeholder="macy201808"
              value={config.title}
              onChange={e => editConfig(e.target.value, 'title')}
            />
          </FormItem>
          <FormItem {...formItemLayout} label="description">
            <Input.TextArea
              autoSize
              showCount
              className="input-lar-input"
              placeholder="description"
              value={config.description}
              onChange={e => editConfig(e.target.value, 'description')}
            />
          </FormItem>
          <FormItem {...formItemLayout} label="keywords">
            <Input.TextArea
              autoSize
              showCount
              className="input-lar-input"
              placeholder="keywords"
              value={config.keywords}
              onChange={e => editConfig(e.target.value, 'keywords')}
            />
          </FormItem>
          <FormItem {...formItemLayout} label={t('merchant')} required>
            <Select
              showSearch
              className="input-lar-input"
              placeholder={t('merchant')}
              value={config.merchantId}
              onChange={e => editConfig(e, 'merchantId')}
              optionFilterProp="children"
            >
              {[
                {
                  id: '0d98c747-97e4-3d00-bcc4-c17c9d557a2b',
                  label: '其他',
                  value: '0d98c747-97e4-3d00-bcc4-c17c9d557a2b',
                },
                ...this.props.baseInfo.merchants,
              ].map(item => (
                <Option key={item.id} value={item.id}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label={t('category')} {...formItemLayout}>
            <FormItem noStyle>
              <Select
                className="input-lar-input"
                placeholder={t('category')}
                onChange={e => editConfig(e, 'categoryIds')}
                value={
                  config.categoryIds?.join ? config.categoryIds?.join(',') : config.categoryIds
                }
              >
                {this.state.categories.map((item, index) => (
                  <Select.Option value={item.categoryIds.join(',')} key={index}>
                    {item.tabName}
                  </Select.Option>
                ))}
              </Select>
            </FormItem>
            <p>
              <Typography.Text type="warning">{t('categoryTipInfo')}</Typography.Text>
            </p>
          </FormItem>
          <FormItem {...formItemLayout} label="link">
            <Input
              className="input-lar-input"
              type="text"
              disabled
              placeholder={t('linkPlaceholder')}
              value={config.link}
            />
          </FormItem>
          <FormItem {...formItemLayout} label={t('backgroundColor')}>
            <Popover
              placement="right"
              title={t('backgroundColor')}
              content={content}
              trigger="click"
            >
              <div
                className="colorBtn"
                style={{ backgroundColor: config.bgColor || '#fff' }}
                onClick={() => {
                  this.setState({ visible: true })
                }}
              ></div>
            </Popover>
          </FormItem>
          <FormItem
            {...formItemLayout}
            name="pageId"
            label="pageId:"
            hasFeedback
            rules={[
              {
                required: true,
                message: 'please input page id',
              },
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  const reg = /[^\x00 -\xff]/g
                  if (!reg.test(value)) {
                    return Promise.resolve()
                  }
                  return Promise.reject(errMessage)
                },
              }),
            ]}
          >
            <Input
              className="input-lar-input"
              type="text"
              disabled={isUpdate}
              placeholder={t('pageIdPlaceholder')}
              value={config.pageId}
              onChange={e => editConfig(e.target.value, 'pageId')}
            />
          </FormItem>
          <FormItem {...formItemLayout} label={t('shareTitle')} required>
            <Input
              className="input-lar-input"
              type="text"
              placeholder={t('shareTitle')}
              value={config.shareTit}
              onChange={e => editConfig(e.target.value, 'shareTit')}
            />
          </FormItem>
          <FormItem {...formItemLayout} label={t('shareSubtitle')} required>
            <Input
              className="input-lar-input"
              type="text"
              placeholder={t('shareSubtitle')}
              value={config.shareDes}
              onChange={e => editConfig(e.target.value, 'shareDes')}
            />
          </FormItem>
          <FormItem {...formItemLayout} label={t('shareImage')} required>
            <Upload {...uploadProps} onChange={this.uploadImg}>
              {config.shareImg ? (
                <img src={config.shareImg} alt="" className="avatar shareImg" />
              ) : (
                <PlusOutlined className="avatar-uploader-trigger" />
              )}
            </Upload>
          </FormItem>
          <FormItem {...formItemLayout} label={t('downloadBar')}>
            <Radio.Group
              onChange={e => editConfig(e.target.value, 'showDownload')}
              value={config.showDownload || false}
            >
              <Radio value={false}>{t('hidden')}</Radio>
              <Radio value={true}>{t('show')}</Radio>
            </Radio.Group>
          </FormItem>
          <FormItem {...formItemLayout} label={t('showShoppingIcon')}>
            <Radio.Group
              onChange={e => editConfig(e.target.value, 'showToCartOrder')}
              value={config.showToCartOrder || false}
            >
              <Radio value={false}>{t('hidden')}</Radio>
              <Radio value={true}>{t('show')}</Radio>
            </Radio.Group>
          </FormItem>
          <FormItem {...formItemLayout} label={t('downloadLink')}>
            <Input
              className="input-lar-input"
              type="text"
              placeholder={t('downloadPlaceholder')}
              value={config.downloadLink}
              onChange={e => editConfig(e.target.value, 'downloadLink')}
            />
          </FormItem>
          <FormItem {...formItemLayout} label={t('templateVersion')} required>
            <Select
              style={{ width: 180 }}
              placeholder={t('templatePlaceholder')}
              value={config.templateVersion}
              onChange={e => editConfig(e, 'templateVersion')}
            >
              {templateList.map(item => {
                return (
                  <Option value={item} key={item}>
                    {item}
                  </Option>
                )
              })}
            </Select>
          </FormItem>
          <FormItem {...formItemLayout} label={t('mode')}>
            <Select
              style={{ width: 180 }}
              placeholder={t('mode')}
              value={config.productLink}
              onChange={this.changeChannel}
              allowClear
            >
              {PRODUCTLINK.map(item => {
                return (
                  <Option value={item.key} key={item.key}>
                    {item.channel}
                  </Option>
                )
              })}
            </Select>
          </FormItem>
        </Form>
        <div className="btnBox">
          <Button className="saveBtn" loading={saveLoading} onClick={saveInfo}>
            {t('save')}
          </Button>
          {/* <Button type='primary' className='publishBtn'>发布</Button> */}
        </div>
      </div>
    )
  }
}
export default connect(
  mapStateToprops,
  mapDispatchToProps
)(withTranslation()(withRouter(BaseConfig)))
